import { render, staticRenderFns } from "./role_auth_config.vue?vue&type=template&id=0554f6d0&scoped=true"
import script from "./role_auth_config.vue?vue&type=script&lang=js"
export * from "./role_auth_config.vue?vue&type=script&lang=js"
import style0 from "./role_auth_config.vue?vue&type=style&index=0&id=0554f6d0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0554f6d0",
  null
  
)

export default component.exports